var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4001 7.26654C13.5222 7.38857 13.5222 7.58644 13.4001 7.70848L11.0418 10.0668C10.9198 10.1888 10.7219 10.1888 10.5999 10.0668C10.4778 9.94477 10.4778 9.74691 10.5999 9.62487L12.9582 7.26654C13.0802 7.1445 13.2781 7.1445 13.4001 7.26654Z",
    fill: "#374151",
    stroke: "#EB4646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5999 7.26654C10.7219 7.1445 10.9198 7.1445 11.0418 7.26654L13.4001 9.62487C13.5222 9.74691 13.5222 9.94477 13.4001 10.0668C13.2781 10.1888 13.0802 10.1888 12.9582 10.0668L10.5999 7.70848C10.4778 7.58644 10.4778 7.38857 10.5999 7.26654Z",
    fill: "#374151",
    stroke: "#EB4646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.22917C10.1013 5.22917 8.5625 6.76801 8.5625 8.66667C8.5625 10.5653 10.1013 12.1042 12 12.1042C13.8987 12.1042 15.4375 10.5653 15.4375 8.66667C15.4375 6.76801 13.8987 5.22917 12 5.22917ZM7.9375 8.66667C7.9375 6.42283 9.75616 4.60417 12 4.60417C14.2438 4.60417 16.0625 6.42283 16.0625 8.66667C16.0625 10.9105 14.2438 12.7292 12 12.7292C9.75616 12.7292 7.9375 10.9105 7.9375 8.66667Z",
    fill: "#374151",
    stroke: "#EB4646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83333 15.6177C8.16525 15.6177 6.78433 16.9336 6.78433 18.6667C6.78433 19.0078 6.50779 19.2843 6.16667 19.2843C5.82554 19.2843 5.549 19.0078 5.549 18.6667C5.549 16.2331 7.50141 14.3823 9.83333 14.3823H14.0833C16.5169 14.3823 18.3677 16.3347 18.3677 18.6667C18.3677 19.0078 18.0911 19.2843 17.75 19.2843C17.4089 19.2843 17.1323 19.0078 17.1323 18.6667C17.1323 16.9986 15.8164 15.6177 14.0833 15.6177H9.83333Z",
    fill: "#374151"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99829 3.74625C5.65035 3.74625 3.74621 5.65039 3.74621 7.99833V16.0017C3.74621 18.3496 5.65035 20.2537 7.99829 20.2537H16.0016C18.3496 20.2537 20.2537 18.3496 20.2537 16.0017V7.99833C20.2537 5.65039 18.3496 3.74625 16.0016 3.74625H7.99829ZM2.24621 7.99833C2.24621 4.82197 4.82193 2.24625 7.99829 2.24625H16.0016C19.178 2.24625 21.7537 4.82197 21.7537 7.99833V16.0017C21.7537 19.178 19.178 21.7537 16.0016 21.7537H7.99829C4.82193 21.7537 2.24621 19.178 2.24621 16.0017V7.99833Z",
    fill: "#374151"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockUser);
export default __webpack_public_path__ + "static/media/lockUser.b72a7797.svg";
export { ForwardRef as ReactComponent };